import React, {Component} from 'react';
import {TagCloud} from 'react-tagcloud'
import './global.css';
import NavBar from './NavBar';
import PageFooter from './PageFooter';

const options = {
    luminosity: 'gray',
    hue: '#607D8B',
}
const data = [
    {value: 'Journalists', count: 38},
    {value: 'Attorneys', count: 30},
    {value: 'Sales Professionals', count: 28},
    {value: 'Assistants', count: 25},
    {value: 'Secretaries', count: 33},
    {value: 'Teachers', count: 18},
    {value: 'Politicians', count: 20},
    {value: 'Police Officers', count: 38},
    {value: 'Elderly People', count: 30},
    {value: 'Finance Professionals', count: 28},
    {value: 'Contractors', count: 25},
    {value: 'Remote Workers', count: 33},
    {value: 'Job Candidates', count: 18},
    {value: 'HR Professionals', count: 20},
    {value: 'Any Agents', count: 38},
    {value: 'Real Estates Agents', count: 30},
    {value: 'Business Owners', count: 28},
    {value: 'Students', count: 25},
    {value: 'Partners', count: 33},
    {value: 'Doctors', count: 18},
    {value: 'Patients', count: 20},
    {value: 'Freelancers', count: 33},
    {value: 'Headhunters', count: 38},
    {value: 'Pupils', count: 25},
    {value: 'Nurses', count: 18},
    {value: 'Teammates', count: 20},
    {value: 'Bloggers', count: 20},
]

class Home extends Component {
    render() {
        return <div className="container">
            <NavBar navigate={this.props.navigate} current='Home' />
            <br/>
            <div className="card" id="shellWhite">
                <div id="content">
                    <p>
                        <h2>Who needs A Call Recorder App?</h2>
                    </p>
                    <TagCloud
                        minSize={18}
                        maxSize={35}
                        tags={data}
                        colorOptions={options}
                        disableRandomColor={false}
                    />
                </div>
            </div>
            <br/>
            <div className="card" id="shellWhite">
                <div id="content">
                    <p>
                        <div>
                            <img class="roundrect" src="/logo192.png" align="left" hspace="0" vspace="0" alt="app icon"
                                 width="108px"/>
                            <p>
                                <h2>A Call Recorder App</h2>
                            </p>
                            <p><h3>Records Regular Phone Calls in the BEST Possible Quality.<br/>Transforms Recorded
                                Audio files into Readable Text Documents.</h3></p>
                        </div>
                    </p>
                    <br/>
                    <p>
                        A Call Recorder is one of the best ways to <strong>record a regular phone
                        call</strong> conversation. We use the <strong>IVR</strong> (Interactive Voice Response)
                        technology to record the phone call
                        conversation in the cloud
                        with the best possible quality.
                    </p>
                    <p>
                        Also, we use the <strong>Best-In-Class ML/AI</strong> (machine learning and artificial
                        intelligence) engine to <strong>transcribe phone calls</strong> in case you need to transform
                        recorded audio files into
                        readable text that includes speaker separation, time codes, and more.
                    </p>
                    <p>
                        <strong>The USA And Canada Phones Only!</strong><br/>
                        Currently, our app and service work for (+1) country code.<br/>
                        However, you can call any country and record phone conversations through the <strong>'Merge And
                        Call'</strong> button. For more information, please read the user guide on our website.

                    </p>
                    <p>
                        <strong>Transcription works for most languages!</strong><br/>
                        The App will record a call in any language.<br/>
                        Transcription works for most languages; however, it has been primarily tested for the most common languages in the US and Canada.
                    </p>
                    <p>
                        <b>A Call Recorder App</b> lets you:
                        <ul>
                            <li> Record phone calls in perfect quality.</li>
                            <li> Record incoming or outgoing calls or calls you are already on, even if you are in
                                headphones.
                            </li>
                            <li> Record conference call (if your plane and the conference support merging lines).
                            </li>
                            <li> Get timestamped transcription of the recorded phone call conversation if needed.</li>
                            <li> Share recorded audio files and transcribed conversations as a text document.</li>
                            <li> Simple pricing and billing without any hidden fees.</li>
                        </ul>
                    </p>
                    <p>
                        Very simple:
                        <ul>
                            <li> Once you download the app, you receive <strong>60</strong> Credit Minutes.</li>
                            <li> SignUp with your Phone Number.</li>
                            <li> Tap the <strong>'Record A Call'</strong> button and choose or dial the destination
                                number. <em>Note: when using this option, the recipient will see our service number
                                instead of your number.</em>
                            </li>
                            <li> Tap the <strong>'Merge And Record'</strong> button on the bottom left if you are
                                already on a call, or first tap it to receive our callback, then dial your recipient
                                and merge — your number appears normally to the recipient with this method.
                            </li>
                            <li> Go to the history of recorded calls and playback the recorded audio files whenever you
                                want.
                            </li>
                            <li> Request Transcription to transform recorded audio files into readable text documents.
                            </li>
                            <li> Share audio and text files through email.</li>
                            <li> Purchase extra minutes when you need them.</li>
                        </ul>
                    </p>
                    <p>
                        <strong>
                            <span className="crimson_text">60 Initial Minutes for FREE!</span><br/>
                            <span className="crimson_text">No Ads!</span><br/>
                            <span className="crimson_text">No Subscription!</span>
                        </strong>
                    </p>
                    <p>
                        Mobile app is available for modern Apple and Android phones.
                    </p>
                </div>
            </div>
            <br/>
            <div id="content" className="content_card_text">
                <p className="normal"><h2>What users say</h2></p>
            </div>
            {/* TODO: replace placeholder text below with real App Store reviews */}
            <div className="card" id="shellWhite">
                <div id="content">
                    <p><b>★★★★★ &nbsp; Works perfectly for my interviews</b></p>
                    <p>"As a journalist I record several calls a week. The audio quality is excellent and the
                       transcription saves me hours of typing. Simple pricing, no surprise charges."</p>
                    <p><i>— App Store review</i></p>
                </div>
            </div>
            <br/>
            <div className="card" id="shellWhite">
                <div id="content">
                    <p><b>★★★★★ &nbsp; Finally a reliable call recorder</b></p>
                    <p>"I tried several apps and this is the only one that consistently records both sides of the
                       conversation clearly. The 60 free minutes to start is a nice touch."</p>
                    <p><i>— App Store review</i></p>
                </div>
            </div>
            <br/>
            <div className="card" id="shellWhite">
                <div id="content">
                    <p><b>★★★★★ &nbsp; Great for client calls</b></p>
                    <p>"I use this for sales calls and the transcription feature is incredibly useful for reviewing
                       what was agreed. Pay-as-you-go means I only pay when I actually need it."</p>
                    <p><i>— App Store review</i></p>
                </div>
            </div>
            <br/>
            <div id="content" className="content_card_text">
                <p className="normal"><h2>App's Preview</h2></p>
            </div>
            <div className="card" id="shellPrimaryNoPadding">
                <div id="content">
                    <div className="row">
                        <div className="column">
                            <img src="/screen1.webp" alt="screenshot 1" width="100%"/>
                        </div>
                        <div className="column">
                            <img src="/screen2.webp" alt="screenshot 2" width="100%"/>
                        </div>
                        <div className="column">
                            <img src="/screen3.webp" alt="screenshot 3" width="100%"/>
                        </div>
                        <div className="column">
                            <img src="/screen4.webp" alt="screenshot 4" width="100%"/>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <p>
                <div className="fast_nav container">
                    <h2>Download App</h2>
                    <ul>
                        <li className="first">
                            <a href="https://apps.apple.com/us/app/a-call-recorder/id1622051987"
                               target="_blank"
                               rel="noopener noreferrer">
                                <img src="/app_store.png" alt="itunes"/>
                            </a>
                        </li>
                        <li>
                            <a href="https://play.google.com/store/apps/details?id=com.answersolutions.recordacall"
                               target="_blank"
                               rel="noopener noreferrer">
                                <img src="/google_play.png" alt="google play"/>
                            </a>
                        </li>
                    </ul>
                </div>
            </p>
            <br/>
            <PageFooter navigate={this.props.navigate} current='Home' />
            <br/>
        </div>
    }
}

export default Home;